<div class="grid">
    <que-manipulations-toolbar [isEmpty]="isEmpty$()"></que-manipulations-toolbar>
    <div class="scroll" [ngClass]="{ expanded: !isFilterListOpen$()}" *ngIf="isResult$(); else thereIsNotResult">
        <que-reports-list-header class="position-sticky" [sortBy]="sort().sortBy"
            [sortDirection]="sort().sortDirection" (sortChange)="onSortChange($event)">
        </que-reports-list-header>
        <div *ngFor="let item of reports$()?.result">
            <que-reports-list-item [report]="item"></que-reports-list-item>
        </div>
        <ng-container *ngFor="let _ of [].constructor(3)">
            <div class="item-in-loading" *ngIf="loadingExtra$()"></div>
        </ng-container>
    </div>
</div>
<ng-template #thereIsNotResult>
    <div class="grid no-result" *ngIf="!loading$(); else loading">
        <que-no-result [isEmpty]="isEmpty$()" [type]="'reports'"></que-no-result>
    </div>
</ng-template>
<ng-template #loading>
    <div class="no-result" *ngIf="loading$()">
        <div *ngFor="let _ of [].constructor(10)" class="item-in-loading load-enimation"></div>
    </div>
</ng-template>
